/**
 * Page agent affichée quand le tenant est suspendu (impayé ou blocage
 * manuel super-admin). Pas de CTA paiement côté agent : c'est au gérant
 * de régulariser.
 */
export function AccountBlockedPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-navy-50 p-6">
      <div className="max-w-md w-full rounded-2xl bg-white p-8 ring-1 ring-navy-100 shadow-sm space-y-3 text-center">
        <h1 className="text-xl font-bold text-navy-800">Compte désactivé</h1>
        <p className="text-sm text-navy-600">
          Votre compte agent est temporairement désactivé. Contactez votre
          agence pour rétablir l'accès.
        </p>
      </div>
    </div>
  );
}
